import { render, staticRenderFns } from "./BootsCertificationBadges.vue?vue&type=template&id=9a8b44cc&scoped=true"
import script from "./BootsCertificationBadges.vue?vue&type=script&lang=js"
export * from "./BootsCertificationBadges.vue?vue&type=script&lang=js"
import style0 from "./BootsCertificationBadges.vue?vue&type=style&index=0&id=9a8b44cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8b44cc",
  null
  
)

export default component.exports